module.exports = __webpack_public_path__ + "img/statistik.60441e36.png";